import styled from "styled-components";
import { Link } from "react-router-dom";

import { pxToRem, withAlpha } from "../../styles/utils";
import { LessonRow } from "../StudentPortal/StudentCourseLesson.styles";
import { StudentMain } from "../StudentPortal/studentPortal.styles";

export const KnowledgeBaseStudentMain = styled(StudentMain)`
  position: relative;
  flex: 1 1 auto;
`;

export const KnowledgeBaseCreateAction = styled.div`
  position: absolute;
  top: ${pxToRem(56)};
  right: ${pxToRem(24)};
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  width: auto;

  > button {
    width: auto;
    min-width: 0;
    flex: 0 0 auto;
  }

  @media (max-width: 1100px) {
    position: static;
    margin: 0 0 ${({ theme }) => pxToRem(theme.spacing.sm)} auto;
  }

  @media (max-width: 700px) {
    width: auto;
    margin-bottom: ${({ theme }) => pxToRem(theme.spacing.md)};
  }
`;

export const KnowledgeBaseCourseHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
`;

export const KnowledgeBaseCourseHeaderMain = styled.div`
  min-width: 0;
  flex: 1 1 auto;
`;

export const KnowledgeBaseCourseEditAction = styled.div`
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  width: auto;

  > button {
    width: auto;
    min-width: 0;
    flex: 0 0 auto;
  }
`;

export const KnowledgeBaseLessonRowShell = styled.div`
  display: flex;
  align-items: stretch;
  border-bottom: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};

  &:last-child {
    border-bottom: 0;
  }
`;

export const KnowledgeBaseLessonRowLink = styled(LessonRow)`
  width: auto;
  min-width: 0;
  flex: 1 1 auto;
  border-bottom: 0;
`;

export const KnowledgeBaseLessonRowEdit = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.md)} 0
    ${({ theme }) => pxToRem(theme.spacing.xs)};
  background: ${({ theme }) => theme.colors.white};
`;

export const CompactLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ theme }) => pxToRem(theme.controlHeight.sm)};
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.sm)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.outline};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: transparent;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 500;
  line-height: 1;
  text-decoration: none;

  &:hover {
    background: ${({ theme }) => theme.colors.inkSurface};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;

export const EmptyState = styled.div`
  padding: ${({ theme }) => pxToRem(theme.spacing.xxl)};
  border: ${pxToRem(1)} dashed ${({ theme }) => theme.borders.outline};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  color: ${({ theme }) => withAlpha(theme.colors.ink, 0.58)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.5;
  text-align: center;
`;

export const DetailBack = styled(Link)`
  display: inline-flex;
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.md)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const DetailMeta = styled.div`
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  color: ${({ theme }) => withAlpha(theme.colors.ink, 0.5)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
`;

export const SectionTitle = styled.h2`
  margin: ${({ theme }) => pxToRem(theme.spacing.xl)} 0
    ${({ theme }) => pxToRem(theme.spacing.sm)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 600;
`;

export const RichContent = styled.div`
  color: ${({ theme }) => withAlpha(theme.colors.ink, 0.78)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.6;

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const MaterialLink = styled.a`
  display: inline-flex;
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.sm)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
`;
